import { render, staticRenderFns } from "./CustomerPayments.vue?vue&type=template&id=c80d1616&scoped=true"
import script from "./CustomerPayments.vue?vue&type=script&lang=js"
export * from "./CustomerPayments.vue?vue&type=script&lang=js"
import style0 from "./CustomerPayments.vue?vue&type=style&index=0&id=c80d1616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80d1616",
  null
  
)

export default component.exports